import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { DesignSystem } from '../models'

export class DesignSystemService extends KsService {
  protected static mainUrl = '/designsystems'

  /**
   * Get the default design system for an organization
   */
  static async getDefault(organizationId: number): Promise<DesignSystem | null> {
    const client = useApiClient()
    return await client.get<DesignSystem>(`${this.mainUrl}/default/${organizationId}`) ?? null
  }

  /**
   * Get design system with all components
   */
  static async getWithComponents(id: number): Promise<DesignSystem | null> {
    const client = useApiClient()
    return await client.get<DesignSystem>(`${this.mainUrl}/${id}/with-components`) ?? null
  }

  /**
   * Get all design systems for an organization
   */
  static async getByOrganization(organizationId: number): Promise<DesignSystem[]> {
    const client = useApiClient()
    return await client.getAll<DesignSystem>(`${this.mainUrl}/organization/${organizationId}`)
  }

  /**
   * Set a design system as the default for an organization
   */
  static async setAsDefault(designSystemId: number, organizationId: number): Promise<DesignSystem | null> {
    const client = useApiClient()
    const axios = client.getAxiosInstance()
    const response = await axios.patch<DesignSystem>(`${this.mainUrl}/${designSystemId}/set-default?organizationId=${organizationId}`)
    return response.data
  }

  /**
   * Clone a design system with all its components
   */
  static async clone(designSystemId: number, newName: string): Promise<DesignSystem | null> {
    const client = useApiClient()
    return await client.postRaw<{ newName: string }, DesignSystem>(`${this.mainUrl}/${designSystemId}/clone`, { newName })
  }
}
